export const Watermelon = () => (
    <div className="watermelon"></div>
)